<template>
  <div :class="getKnowledgeStatus && getKnowledgeSigns.length && 'onSign'">
    <div class="word-item" :class="[w.isSign ? 'word-line' : '', getCurKnowledge.signId == w.signId ? 'on' : '']"
      :style="getRowStyle(i,w)" v-for="(w, i) in row.words" :key="i"  :data-row="w.signId">
      <div class="mark" v-if="w.markIsLeft && w.mark">{{ w.mark }}</div>
      <div class="word" :class="[w.minWidth && styleType == 2 ? 'minWidth-' + w.minWidth : '', w.py ? 'has-piny' : '']">
        <div class="piny" v-if="w.py">{{ w.py }}</div>
        <div class="zh" :style="{'color': colorArr[w.level - 1] || ''}" :class="[w.isDash ? 'isDash' : '', w.symType ? 'symType-' + w.symType : '']" v-text="w.zh">
        </div>
      </div>
      <div class="mark" v-if="w.markIsRight && w.mark">{{ w.mark }}</div>
    </div>
    <div class="word-sign" :class="getCurKnowledge.signId == row.signId && 'act'"
      v-if="getKnowledgeStatus && getKnowledgeSigns.length && row.signId > -1" @click="onKnowledge(row)" :style="getTop(row.signId)">
      {{ row.signId - overall ? (row.signId - overall) : '全' }}
      <span class="word-sign small content" @click.stop="onKnowledge('classStatus', true)" v-if="getCurKnowledge.voiceUrl || getCurKnowledge.content">讲解</span>
      <span class="word-sign small class" @click.stop="onKnowledge('videoStatus', true)" v-if="getCurKnowledge.videoUrl">微课</span>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
// let eleW;
export default {
  props: {
    styleType: {
      type: Number,
      default: 0
    },
    row: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      colorArr: ['#00B40A', '#038BEA', '#FFAC00', '#FF5C5C'],
    }
  },
  computed: {
    ...mapGetters(["getKnowledgeStatus", "getCurKnowledge", "getKnowledgeSigns","getKnowledgeSettings"]),
    overall() {
      return this.getKnowledgeSigns.findIndex(item => item.isOverall) > -1 ? 1 : 0;
    },
    // getIndent() {
    //   return (isIndent) => {
    //     const ele = document.querySelector('#line1 .word-item');
    //     if(!isIndent || !ele)return '';
    //     eleW = eleW || ele.clientWidth;
    //     return `padding-left:${eleW * 2}px;`;
    //   }
    // }
    
  },
  methods: {
    // getTop(ele) {
    //   const parent = document.getElementsByClassName('sign_' + ele);
    //   return parent.length ? {
    //     top: parent[0].querySelector('.word').offsetHeight / 2 - 20 + 'px'
    //   } : {}
    // },
    getTop(ele) {
      const parent = document.getElementsByClassName('sign_' + ele);
      if(!parent.length) return '';
      const parentRect = document.getElementsByClassName('sign_' + ele)[0].getBoundingClientRect();
      const childRect = document.querySelector(`.sign_${ele} .word-line`).getBoundingClientRect()
      const size = (this.getKnowledgeSettings.size || 1)
      return {
        top: (childRect.top - parentRect.top + (childRect.height / 2 - 20)) / size + 'px'
      }
    },
    getRowStyle(index,w) {
      let row = this.row
      // if (row.textIndent && !index) {
      const isIndent = row.textIndent && !index;
        const mw = w.minWidth && this.styleType == 2;
        let lw = 120;
        if([3,5,6].includes(+mw))lw = [100,140,160][[3,5,6].indexOf(+mw)]
        return {
          'text-indent': isIndent ? (row.textIndent + 'px') : 0,
          'margin-left': w.isIndent ? (lw + 'px') : 0,
        }
      // }
    },
    onKnowledge(row, val) {
      if (typeof row == "string") {
        this.$store.commit("setCurKnowledge", {
          ...this.getCurKnowledge,
          [row]: val,
        });
      } else {
        // =============???===
        if(row.signId != this.getCurKnowledge.signId) this.$store.commit("setGlobalAudio", false);

        this.$store.commit("setCurKnowledge", {
          signId: row.signId,
          domId: 'sign_' + row.signId,
          ...this.getKnowledgeSigns[row.signId - 1]
        });
      }
    }
  }
}
</script>
<style lang="less" scoped>
// .indent {
//   text-indent: 100px;
// }
.onSign {
  position: relative;
  display: inline-block;
  // .word-line {
  //   // border-bottom: 6px solid rgba(251, 124, 51, .2);
  //   // box-sizing: border-box;
  //   position: relative;
  //   &::after {
  //     content: '';
  //     width: 100%;
  //     height: 6px;
  //     position: absolute;
  //     bottom: 8px;
  //     left: 0;
  //     background-color: rgba(251, 124, 51, .2);
  //     display: inline-block;
  //   }

  //   &.on {
  //     border-color: #FB7C33;
  //   }
  // }

  .word-sign {
    display: inline-block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    background: #FFF2EA;
    border: 1px solid #FB7C33;
    font-size: 20px;
    color: #FB7C33;
    cursor: pointer;
    box-sizing: border-box;
    position: relative;
    letter-spacing: 0;
    position: absolute;
    top: 30px;
    right: -14px;
    transform: translateX(50%) scale(.94);
    text-align: center;

    &.act {
      background: #FB7C33;
      color: #fff;
      // transform: translateX(50%);

      .small {
        display: inline-block;
      }
    }

    &.small {
      // transform: scale(1);
      position: absolute;
      width: 34px;
      height: 34px;
      line-height: 34px;
      font-size: 11px;
      display: none;
      z-index: 2;
      &:nth-child(1) {
        left: 24px;
        top: 12px;
      }
      &:nth-child(2) {
        left: -6px;
        top: 44px;
      }
    }
  }
}
</style>